<div id="facility-container">
  <p-blockUI [blocked]="loading === true" />
  @if (!this._deviceService.isMobile()) {
    <div>
      @if (elements) {
        <div id="facility-action-buttons">
          <div class="buttons">
            <div id="business-units-wrapper">
              <app-business-unit-filter
                (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
                #buFilter
              />
            </div>
            <div class="switch">
              <label
                >{{ 'LOCATION.LABEL.HIDDEN_FACILITIES' | translate }}:</label
              >
              <p-toggleswitch
                name="showHiddenFacilities"
                class="hidden-facility-switch"
                [(ngModel)]="showHiddenFacilities"
                (onChange)="refresh()"
              />
            </div>
            @if (!isMobileDevice()) {
              <div>
                @if (canCreate) {
                  <button
                    pButton
                    class="width-eighty"
                    label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
                    icon="fa fa-fw fa-plus-circle"
                    (click)="newFacility()"
                  ></button>
                }
                <button
                  pButton
                  class="refresh-button width-twenty"
                  icon="fa fa-fw fa-refresh"
                  (click)="refresh()"
                ></button>
              </div>
            }
            @if (!isMobileDevice()) {
              <div>
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
                  icon="fa fa-fw fa-eraser"
                  (click)="clearTable()"
                ></button>
              </div>
            }
          </div>
        </div>
      }
      <app-progress-spinner [enabled]="!elements" />
      <div [style.display]="!elements ? 'none' : ''">
        <app-general-grid
          [values]="elements"
          [columns]="columns"
          [loading]="loading"
          [rows]="rows"
          [totalRecords]="totalRecords"
          [filterable]="true"
          [screenName]="screenName"
          [lazy]="true"
          (lazyLoad)="lazyLoad($event)"
          [includeExportCSV]="false"
          (changeViewEvent)="changeViewEvent($event)"
          scrollHeight="calc(100vh - 256px)"
          [usePaginator]="true"
          [rowsPerPageOptions]="[50, 100, 200]"
          #grid
        />
      </div>
    </div>
  }

  @if (this._deviceService.isMobile()) {
    <p-panel
      [showHeader]="true"
      header="Filters"
      [toggleable]="true"
      [(collapsed)]="mobileFilterCollapsed"
    >
      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <app-facility-mobile-filter
            (mobileFilterEvent)="mobileFilter($event)"
          />
        </div>
      </div>
    </p-panel>
  }
  @if (this._deviceService.isMobile()) {
    <div>
      @if (elements) {
        <div class="ui-g ui-fluid" id="facility-action-buttons">
          <app-progress-spinner [enabled]="!elements" />
          <div [style.display]="!elements ? 'none' : ''">
            <app-general-grid
              [values]="elements"
              [columns]="columns"
              [loading]="loading"
              [rows]="rows"
              [totalRecords]="totalRecords"
              [filterable]="true"
              [screenName]="screenName"
              [lazy]="true"
              (lazyLoad)="lazyLoad($event)"
              [includeExportCSV]="false"
              (changeViewEvent)="changeViewEvent($event)"
              scrollHeight="calc(100vh - 175px)"
              [usePaginator]="true"
              [rowsPerPageOptions]="[50, 100, 200]"
              #grid
            />
          </div>
        </div>
      }
    </div>
  }
</div>
